import script from "./EspressDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./EspressDetailView.vue?vue&type=script&setup=true&lang=js"

import "./EspressDetailView.vue?vue&type=style&index=0&id=d531a0ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d531a0ba"]])

export default __exports__